// extracted by mini-css-extract-plugin
export default {"item":"item--3N3A47VrGm"};